import React from "react";

export default function AvatarComponent() {
  return (
    <div
      style={{
        boxShadow:
          "0px 10px 10px 0px rgba(0, 0, 0, 0.04), 0px 20px 25px rgba(0, 0, 0, 0.10)",
      }}
      className="w-[224px] py-4 rounded-[8px]"
    >
      <div className="flex items-center justify-center">
        <div className="w-[88%]">
          <p className="text-[0.94rem] text-[#111928] font-[600]">Jese Leos</p>
          <p className="text-[0.94rem] text-[#111928]">name@example.com</p>
        </div>
      </div>
      <div className="w-full h-[1px] bg-[#F3F4F6] mt-3"></div>
      <div className="flex items-center justify-center">
        <div className="w-[88%]">
          <div className="h-[2rem] flex items-center cursor-pointer">
            <p className="text-[0.80rem] text-[#6B7280] ">Your profile</p>
          </div>
          <div className="h-[2rem] flex items-center cursor-pointer">
            <p className="text-[0.80rem] text-[#6B7280]">Change Password</p>
          </div>
          <div className="h-[2rem] flex items-center cursor-pointer">
            <p className="text-[0.80rem] text-[#6B7280]">Sign out</p>
          </div>
        </div>
      </div>
    </div>
  );
}
